/* eslint-disable ember/no-computed-properties-in-native-classes, ember/require-computed-property-dependencies, warp-drive/no-legacy-request-patterns */
import Fragment from 'ember-data-model-fragments/fragment';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import { fragmentOwner } from 'ember-data-model-fragments/attributes';
import moment from 'moment';
import type AttendanceRecord from 'linced-app/models/attendance/record';

// Proto: attendance.Movement.
export default class Movement extends Fragment {
  declare [Type]: 'attendance/movement';

  // time is the time at which the movement occurred, as a unix timestamp.
  @attr('number', { defaultValue: 0 })
  declare time: number;

  // timeString is `time` formatted as HH:mm.
  @computed('time')
  get timeString() {
    if (!this.time) {
      // Fall back to current time.
      return moment().format('HH:mm');
    }
    return moment.unix(this.time).format('HH:mm');
  }

  // code is the attendance code which applies to this movement.
  @attr('string', { defaultValue: '' })
  declare code: string;

  // authorId is the unique identifier of the Person who created (or last
  // edited) this movement.
  @attr('string', { defaultValue: '' })
  declare authorId: string;

  // author maps the authorId to a Person record.
  @computed('authorId')
  get author() {
    return this.store.peekRecord('person', this.authorId);
  }

  // notes contains any information regarding this movement.
  @attr('string', { defaultValue: '' })
  declare notes: string;

  // record is a reference to the attendance record to which this movement
  // belongs.
  @fragmentOwner()
  declare record: AttendanceRecord;

  // period is a reference to the attendance period during which this movement
  // occurred.
  @alias('record.period')
  declare period: unknown;
}
